﻿//Make sure console.log is available to not blow up browser
if (typeof console == "undefined") {
    window.console = {
        log: function () { }
    };
}